/**
 * Use altClass on the <message altClass=''/> tag to set alternate css class
 *
 * Usage: use 'autohide' parameter to enable/disable the automatic hiding of the message bar
 * <message autohide="true|false"/>
 */
angular.module('qkr').directive('message', ['messageService', '$compile', 'utils', '$rootScope', function(messageService, $compile, utils, $rootScope) {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        template: '<div class="message" style="display:none; text-align: center;"><span></span> <strong ng-click="close()" class="message-dismiss-btn">OK</strong></div>',
        link($scope, element, attrs) {
            /**
             * Listens for a message to display
             */
            $scope.$on('messageBroadcast', (e, message) => {
                showMessage();
            });

            /**
             * Listens for an event to hide the message
             */
            $scope.$on('messageHideBroadcast', (e, message) => {
                hideMessage();
            });

            /**
             * Close function - is used on the message box ng-click
             */
            $scope.close = function() {
                $rootScope.$broadcast('messageHideBroadcast'); // Close all messages
            };

            function showMessage() {
                // Reset the message css classes
                $(element).removeClass();
                $(element).addClass('message');

                // Add alternate style if any
                if (attrs.altclass) {
                    $(element).addClass(attrs.altclass);
                }

                // Set the style for the current message scope
                const message = messageService.getMessage();
                $(element).addClass('message-' + message.type);

                // $compile message text so it can be added to the angular scope (e.g. enables things like ng-click)
                const el = $compile('<span>' + _.escape(message.text) + '</span>')($scope);
                $('span', element).html(el);

                // Show the message
                $(element).slideDown('fast', () => {});

                const inModal = (attrs.inModal !== null);
                if (inModal) {
                    $('#' + attrs.inModal).scrollTop(0);
                } else {
                    utils.scrollToTop();
                }

                const autohide = angular.isUndefined(attrs.autohide) || attrs.autohide === 'true';
                if (autohide) {
                    // Cancel any open timers
                    if ($scope.timer) {
                        window.clearTimeout($scope.timer);
                    }

                    const defaults = {
                        hideMessageTime: attrs.autohidetime || 30000
                    };

                    $scope.timer = window.setTimeout(hideMessage, parseInt(defaults.hideMessageTime, 10));
                }
            }

            function hideMessage() {
                $(element).slideUp('fast');
            }
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/message.js